module.exports = __webpack_public_path__ + "fonts/icomoon.8715eb7.woff";